import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SITE_URL } from "@/lib/site";
import { ChevronRight } from "lucide-react";

const SITE = "FX Motor Sporları";

const setMeta = (sel, attr, key, value) => {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(sel.startsWith("link") ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(sel.startsWith("link") ? "href" : "content", value);
};

export const usePageMeta = (title, description) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `Enduro, Tur ve Eğitim Çekmeköy Ömerli | ${SITE}`;
    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    document.title = full;
    setMeta('link[rel="canonical"]', "rel", "canonical", url);
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    setMeta('meta[property="og:title"]', "property", "og:title", full);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", full);
    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    }
  }, [title, description, pathname]);
};

export const PageHero = ({ eyebrow, title, intro, img, alt, video, crumbs = [] }) => (
  <section data-testid="page-hero" className="relative flex min-h-[62svh] items-end overflow-hidden border-b border-white/10 pt-20">
    {img && <img src={img} alt={alt || title} className={`absolute inset-0 h-full w-full object-cover ${video ? "object-[50%_70%]" : ""}`} />}
    {video && <video src={video} poster={img} autoPlay muted loop playsInline preload="auto" data-testid="page-hero-video" className="absolute inset-0 h-full w-full object-cover object-[50%_70%] motion-reduce:hidden" />}
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
    <div className="relative mx-auto w-full max-w-7xl px-5 pb-14 md:px-8 md:pb-20">
      <nav aria-label="breadcrumb" className="mb-6 flex flex-wrap items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-neutral-400">
        <Link to="/" className="transition-colors hover:text-white" data-testid="breadcrumb-home">Ana Sayfa</Link>
        {crumbs.map((c) => (
          <span key={c.label} className="flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3" />
            {c.to ? <Link to={c.to} className="transition-colors hover:text-white">{c.label}</Link> : <span className="text-white">{c.label}</span>}
          </span>
        ))}
      </nav>
      {eyebrow && <p className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-300"><span className="h-[2px] w-8 bg-brand" />{eyebrow}</p>}
      <h1 data-testid="page-title" className="max-w-4xl font-display text-6xl uppercase leading-[0.9] text-white md:text-8xl">{title}</h1>
      {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-300 md:text-lg">{intro}</p>}
    </div>
  </section>
);
